import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'

import CanSendProvider from '../../../../providers/CanSendProvider'
import Controls from './Controls'
import Input from './Input'
import BaseModal from '../../../molecules/ChatModals/BaseModal2'

import {
  endTaskCreate,
  selectChatBox,
  setHeight,
  switchSession
} from '../../../../slices/chatBoxSlice'
import { useQueueState } from '../../../../providers/QueueStateProvider'
import { useChatEditState } from '../../../../providers/ChatEditStateProvider'
import { useChatScroll } from '../../../../providers/ChatScrollProvider'
import useSize from '../../../../hooks/useSize'
import useStyles from './styles'

const ChatBox = () => {
  const dispatch = useAppDispatch()
  const { values } = useAppSelector(selectChatBox)
  const { quickScrollToBottom } = useChatScroll()

  const { id } = useQueueState()
  const { end: endEdit } = useChatEditState()
  const target = React.useRef(null)
  const size = useSize(target)

  const classes = useStyles()

  // Saves / restores chat box state when switching conversations
  React.useEffect(() => {
    dispatch(switchSession(id))

    // Stop editing
    endEdit()
  }, [dispatch, id, endEdit])

  const handleCloseTaskModal = React.useCallback(() => {
    dispatch(endTaskCreate())
  }, [dispatch])

  React.useLayoutEffect(() => {
    dispatch(setHeight(Math.round(size?.height)))
    setTimeout(() => quickScrollToBottom(), 0)
  }, [size?.height, dispatch, quickScrollToBottom])

  return (
    <CanSendProvider>
      <div className={classes.root}>
        <div className={classes.block} />

        <div className={classes.chat} ref={target}>
          <Controls />

          <Input />
        </div>
      </div>

      {values.onTask && (
        <BaseModal open onClose={handleCloseTaskModal} title='New Task Modal'>
          CREATING TASK MODAL, not yet implemented
        </BaseModal>
      )}
    </CanSendProvider>
  )
}

export default ChatBox
